const doc = [({"ko":({"adminLabelHotelFilter":({"filterName":"필터 이름", "masterFilterId":"필터 항목", "type":"유형"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;